module.exports = {"id":"220048","name":"Simone Scuffet","rating":"74","photo":"./data/images/photos/3/220048.png","club":{"name":"Udinese","logo":"./data/images/clubs/Udinese.png"},"positions":["G"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/SimoneScuffet0.json
// module id = 3972
// module chunks = 0